import { Routes } from '@angular/router';

export const userSecRoutes: Routes = [
  {
    path: 'user-profile',
    data: { moduleCode: 'usr_profile' },
    children: [
      { path: '', loadComponent: () => import('./user-profile/user-profile').then((m) => m.UserProfile) },
      { path: 'add', loadComponent: () => import('./user-profile/details/details').then((m) => m.UserDetails) },
      { path: 'details/:id', loadComponent: () => import('./user-profile/details/details').then((m) => m.UserDetails) },
      { path: 'import', loadComponent: () => import('./user-profile/user-import/user-import').then((m) => m.UserImport) }
    ]
  },

  // User Request
  {
    path: 'user-request',
    data: { moduleCode: 'usr_req' },
    children: [
      { path: '', loadComponent: () => import('./user-request/user-request').then((m) => m.UserRequest) },
      { path: 'details/:id', loadComponent: () => import('./user-request/details/details').then((m) => m.UserRequestDetails) }
    ]
  },

  // User Department
  {
    path: 'user-department',
    data: { moduleCode: 'usr_depart' },
    children: [
      { path: '', loadComponent: () => import('./user-department/user-department').then((m) => m.UserDepartment) },
      { path: 'add', loadComponent: () => import('./user-department/details/details').then((m) => m.UserDepartmentDetails) },
      { path: 'details/:id', loadComponent: () => import('./user-department/details/details').then((m) => m.UserDepartmentDetails) }
    ]
  },

  // User Role
  {
    path: 'user-role',
    data: { moduleCode: 'usr_role' },
    children: [
      { path: '', loadComponent: () => import('./user-role/user-role').then((m) => m.UserRole) },
      { path: 'add', loadComponent: () => import('./user-role/details/details').then((m) => m.UserRoleDetails) },
      { path: 'details/:id', loadComponent: () => import('./user-role/details/details').then((m) => m.UserRoleDetails) }
    ]
  },

  // User Group
  {
    path: 'user-group',
    data: { moduleCode: 'usr_grp' },
    children: [
      { path: '', loadComponent: () => import('./user-group/user-group').then((m) => m.UserGroup) },
      { path: 'add', loadComponent: () => import('./user-group/details/details').then((m) => m.UserGroupDetails) },
      { path: 'details/:id', loadComponent: () => import('./user-group/details/details').then((m) => m.UserGroupDetails) }
    ]
  },

  // User Reassignment
  {
    path: 'user-reassignment',
    data: { moduleCode: 'usr_reass' },
    children: [
      { path: '', loadComponent: () => import('./user-reassignment/user-reassignment').then((m) => m.UserReassignment) },
      { path: 'add', loadComponent: () => import('./user-reassignment/details/details').then((m) => m.UserReassignmentDetails) },
      { path: 'details/:id', loadComponent: () => import('./user-reassignment/details/details').then((m) => m.UserReassignmentDetails) }
    ]
  },

  // User Reassignment Request
  {
    path: 'user-reassignment-request',
    data: { moduleCode: 'usr_reass_req' },
    children: [
      {
        path: '',
        loadComponent: () => import('./user-reassignment-request/user-reassignment-request').then((m) => m.UserReassignmentRequest)
      },
      {
        path: 'details/:id',
        loadComponent: () => import('./user-reassignment/details/details').then((m) => m.UserReassignmentDetails),
        data: { reqModuleType: 'approver' }
      }
    ]
  },

  // User Security Preferences
  {
    path: 'user-security-preferences',
    data: { moduleCode: 'usr_sec_pref' },
    children: [{ path: '', loadComponent: () => import('./user-sec-preferences/user-sec-preferences').then((m) => m.UserSecPreferences) }]
  },

  // User Access Log
  {
    path: 'user-access-log',
    data: { moduleCode: 'usr_acc_log' },
    children: [{ path: '', loadComponent: () => import('./user-access-log/user-access-log').then((m) => m.UserAccessLog) }]
  }
];
